<template>
  <div class="width-100 min-height bg-lightgrey bg-image flex-column" style="padding: 0 5%">
    <div class="width-100 bg-white br-reg flex-column" style="margin-bottom: 90px; min-height: 10rem; margin-top: 4rem; padding: 5% 5%">
      <div
        class="width-100 flex-column align-items-center justify-content-start margin-bs"
        style="border-bottom: 1px solid #eee; padding-bottom: 15px"
      >
        <div class="flex-row align-items-center justify-content-spaceBetween width-100">
          <div class="fs-mid fm-sh-medium">
            全部记录
            <van-icon name="arrow" size="16" color="black" />
          </div>
          <div class="fs-mid fm-sh-medium flex-row align-items-center justify-content-center" @click="show = true">
            {{ columns[searchObj.state].text }}
            <van-image :src="require('../assets/image/prizeManagement/down.png')" class="margin-ls" width="0.6rem" height="0.3rem" />
          </div>
        </div>
      </div>
      <div id="body-id" class="flex-column align-items-center justify-content-start width-100 margin-ts">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width-100 height-100">
          <van-list v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '没有更多了'" @load="onLoad" class="width-100">
            <div
              v-for="(item, key) in list"
              :key="key"
              :class="['width-100', key != list.length - 1 ? 'margin-b' : '']"
              :style="{ borderBottom: key != list.length - 1 ? '1px solid #eee' : 'unset', paddingBottom: key != list.length - 1 ? '20px' : '0' }"
            >
              <div class="flex-row align-items-center justify-content-spaceBetween line-height0 margin-b" style="height: 1rem">
                <div class="fs-mid fm-sh-medium">{{ item.source_type_name }}</div>
                <div class="fs-mid-sml fm-sh-regular" :style="{ color: item.state_name == '待开奖' ? '#FF8526' : '#979797' }">
                  {{ item.state_name }}
                </div>
              </div>
              <div class="width-100 margin-ts flex-row align-items-star justify-content-spaceBetween position-relative">
                <div
                  class="br-reg flex-row align-items-center justify-content-center"
                  :style="{
                    border: '1px solid #e3e3e3',
                    width: (topCardWidth * 0.26).toFixed(0) + 'px',
                    height: (topCardWidth * 0.26).toFixed(0) + 'px'
                  }"
                >
                  <van-image :src="item.picture_url" width="90%" height="90%" fit="fill" />
                </div>
                <div class="width-70">
                  <div class="fs-mid-sml black fm-sh-medium">{{ item.name }}</div>
                  <div class="fs-sml grey-999 fm-sh-medium" v-if="!item.failure_time">开奖时间：{{ item.cre_time }}</div>
                  <div class="fs-sml grey-999 fm-sh-medium" v-if="item.failure_time">失效时间：{{ item.failure_time }}</div>
                  <div class="fs-sml grey-999 fm-sh-medium" v-if="item.num">数量：{{ item.num }}</div>
                </div>
                <div class="position-absolute black flex-row align-items-center justify-content-end" style="bottom: 0; right: 0">
                  <div
                    class="fs-sml fm-sh-medium black div-button bg-lightgrey"
                    style="color: #666"
                    @click="routerPush({ path: '/prizeClaimDetails', query: { id: item.id } })"
                  >
                    查看详情
                  </div>
                  <div
                    v-if="item.state == 1"
                    class="fs-sml fm-sh-medium black div-button margin-ls"
                    style="color: #3185d9; background-color: #caecff"
                    @click="routerPush({ path: '/writePlace', query: { ...item } })"
                  >
                    填写收货信息
                  </div>
                </div>
              </div>
            </div>
            <van-empty
              v-if="list.length == 0"
              class="custom-image"
              :image="require('../assets/image/prizeManagement/empty-image.png')"
              description="暂无数据"
            />
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-overlay :show="show" class="flex-column align-items-center justify-content-end">
      <div class="wrapper width-100">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
      </div>
    </van-overlay>
    <Tabbar active="4" />
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue';
import { getWinningRecordLists, getWinningRecordInfo } from '@/api/prizeManagement';
export default {
  name: 'prizeManagement',
  data() {
    return {
      refreshing: false,
      listObj: {},
      columns: [
        { text: '全部', value: 0 },
        { value: 1, text: '待填写收货地址' },
        { value: 2, text: '待发货' },
        { value: 3, text: '待核销' },
        { value: 4, text: '已完成' }
      ],
      show: false,
      list: [],
      topCardWidth: '',
      searchObj: {
        pageNum: 1,
        state: 0
      },
      loading: false,
      finished: false,
      clickNum: ''
    };
  },
  components: {
    Tabbar
  },
  mounted() {
    this.$nextTick(() => {
      this.topCardWidth = document.getElementById('body-id') ? document.getElementById('body-id').clientWidth : '';
    });
    this.getWinningRecordLists();
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(v) {
        if (v === '/prizeManagement') {
          if (this.clickNum) {
            getWinningRecordInfo({ id: this.clickNum })
              .then((res) => {
                if (res.code == 0) {
                  let list = this.list.map((item) => {
                    if (item.id == res.data.id) {
                      item = res.data;
                    }
                    return item;
                  });
                  this.list = list;
                  for (let key in this.listObj) {
                    this.listObj[key] = this.listObj[key].map((item) => {
                      if (item.id == res.data.id) {
                        item = res.data;
                      }
                      return item;
                    });
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else if (v != '/prizeClaimDetails') {
          this.$destroy();
        }
      }
    }
  },
  methods: {
    onCancel() {
      this.show = false;
    },
    onConfirm(value) {
      this.list = []; // 重置数据
      console.log(value, 'value');
      this.show = false;
      this.searchObj.state = value.value;
      this.searchObj.pageNum = 1;
      for (let key in this.listObj) {
        this.listObj[key] = [];
      }
      this.getWinningRecordLists();
    },
    routerPush(item) {
      this.$router.push(item);
      this.clickNum = item.query.id;
    },
    onRefresh() {
      this.searchObj.pageNum = 0;
      this.loading = true;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    async onLoad() {
      this.refreshing = false;
      this.searchObj.pageNum = this.searchObj.pageNum + 1;
      await this.getWinningRecordLists();
    },
    async getWinningRecordLists() {
      console.log(this.list);
      let pageNum = this.searchObj.pageNum;
      await getWinningRecordLists({ page: this.searchObj.pageNum, state: this.searchObj.state })
        .then((res) => {
          if (res.code == 0) {
            this.listObj[pageNum] = res.data;
            let listObj = this.listObj;
            listObj[pageNum] = res.data;
            let list = [];
            for (let key in this.listObj) {
              this.listObj[key].forEach((item) => {
                list.push(item);
              });
            }
            this.list = list;
            this.loading = false;
            if (res.data.length == 0) {
              this.finished = true;
            }
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/image/prizeManagement/bg-image.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.div-button {
  padding: 4px 8px;
  border-radius: 0.25rem;
  line-height: 12px;
}
.van-overlay {
  z-index: 1000;
}
</style>
